package fr.labodoc.healthProfessional.webApp.data.model

data class MedicalDiplomaModel(
  val id: String,
  val name: String,
  val healthDirectoryProfessionCode: String,
  val labodocMedicalSpeciality: MedicalSpeciality
) {
  data class MedicalSpeciality(
    val id: String,
    val medicalProfession: MedicalProfession,
    val name: String,
    val medicalInterests: List<MedicalInterest>
  ) {
    data class MedicalProfession(
      val id: String,
      val name: String
    )

    data class MedicalInterest(
      val id: String,
      val name: String
    )
  }
}
